import { setLoading, setGlobalMessage } from '../app';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import FIELDS from 'eebac/constants/fields/compnay/user/schedule/fields';
import { ALERT_SEVERITY, ERROR_MESSAGES, VALIDATION_MESSAGES } from 'eebac/constants';
import { Catch } from '../api_exception';
import { loadRfqs, openSchedule } from './user/work/rfqs';


const BASE_PATH = 'COMPANY_SCHEDULE_INFO';

export const SET_SCHEDULE_INFO_DATA = `${BASE_PATH}/SET_SCHEDULE_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;

export const sendSchedule = (id, isEdit = false, isPost = false, vendorId = "") =>
    (dispatch, getState, client) => {

        dispatch(setLoading(true));

        let state = getState();
        state = state.COMPANY_SCHEDULE_DATA;

        let apiData = ApiDataHelper.get(state, FIELDS);

        apiData.isRfq = !isPost;
        apiData.postId = id;
        apiData.vendorId = vendorId;

        let request = null;
        if (isEdit) {
            request = client.put("/company/meeting_schedule/", apiData);
        } else {
            request = client.post("/company/meeting_schedule", apiData);
        }

        request
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(clearScheduleInfoData());
                    if (!isPost) {
                        dispatch(openSchedule(false, null));
                        dispatch(loadRfqs());
                    }
                } else {
                    if (result.fieldErrors &&
                        Array.isArray(result.fieldErrors)) {
                        dispatch(setScheduleInfoData(result.fieldErrors))
                    }

                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }

            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const setScheduleInfoData = data => ({
    type: SET_SCHEDULE_INFO_DATA,
    data
});


export const clearScheduleInfoData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    meetingOn: new Date(),
    venue: "",
    contactPerson: '',
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_SCHEDULE_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case CLEAR_INFO_DATA:
            return { ...initialState }
    }

    return state;
}